var _path, _path2, _path3, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 381,
    viewBox: "0 0 409 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.173 131.276L256.436 154.522C262.603 158.083 266.412 164.654 266.436 171.775L266.592 217.696C266.617 224.869 262.798 231.506 256.584 235.089L216.537 258.184C210.35 261.751 202.73 261.749 196.545 258.179L156.058 234.803C149.873 231.232 146.061 224.634 146.058 217.493L146.035 171.331C146.031 164.122 149.908 157.469 156.181 153.917L196.32 131.192C202.485 127.702 210.037 127.734 216.173 131.276Z",
    stroke: "#8B8600",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.921 160.955C235.789 157.827 175.524 170.464 175.524 246.038",
    stroke: "#8B8600",
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.921 226.066C235.789 229.194 175.524 216.556 175.524 140.983",
    stroke: "#8B8600",
    strokeWidth: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 194.5,
    r: 96.5,
    stroke: "#8B8600",
    strokeOpacity: 0.5,
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 195,
    r: 138,
    stroke: "#8B8600",
    strokeOpacity: 0.25,
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 195,
    r: 181,
    stroke: "#8B8600",
    strokeOpacity: 0.1,
    strokeWidth: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 142.581,
    y1: 194,
    x2: 5.0002,
    y2: 194,
    stroke: "url(#paint0_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 142.581,
    y1: 177,
    x2: 5.0002,
    y2: 177,
    stroke: "url(#paint1_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 142.58,
    y1: 211,
    x2: 4.99995,
    y2: 211,
    stroke: "url(#paint2_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: -5,
    x2: 142.58,
    y2: -5,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 244 248)",
    stroke: "url(#paint3_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: -5,
    x2: 142.58,
    y2: -5,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 244 248)",
    stroke: "url(#paint4_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: -5,
    x2: 142.58,
    y2: -5,
    transform: "matrix(1 0 0 -1 261 194)",
    stroke: "url(#paint5_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 232.17,
    y1: 124.978,
    x2: 300.96,
    y2: 5.83012,
    stroke: "url(#paint6_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 252.17,
    y1: 134.978,
    x2: 320.96,
    y2: 15.8301,
    stroke: "url(#paint7_linear_1_87)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_87",
    x1: 147.747,
    y1: 188.905,
    x2: -0.104676,
    y2: 188.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_87",
    x1: 147.747,
    y1: 171.905,
    x2: -0.104676,
    y2: 171.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_87",
    x1: 147.746,
    y1: 205.905,
    x2: -0.10492,
    y2: 205.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_87",
    x1: -0.165888,
    y1: 0.0954956,
    x2: 147.685,
    y2: 0.181415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_87",
    x1: -0.165888,
    y1: 0.0954956,
    x2: 147.685,
    y2: 0.181415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_87",
    x1: -0.165888,
    y1: 0.0954956,
    x2: 147.685,
    y2: 0.181415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_87",
    x1: 234,
    y1: 132,
    x2: 308,
    y2: 3.99988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_87",
    x1: 254,
    y1: 142,
    x2: 328,
    y2: 13.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8600"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage2);
export default __webpack_public_path__ + "static/media/HeroImage2.288b3c1e5c649e0d7f4e7cef1d3bb34a.svg";
export { ForwardRef as ReactComponent };